<mat-card class="mag" style="width: max-content; box-sizing: border-box; max-width: calc(100% - 40px);">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Practitioners Management</mat-card-title>
                <mat-card-subtitle>Manage all practitioners in the system</mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="justify-content: flex-end; flex-wrap: wrap;">
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
                <a *ngIf="canAddPractitionerRegistration()" mat-flat-button extended class="primary-button small-button"
                    [routerLink]="['/app/practitioner-register']">
                    <mat-icon>person_add</mat-icon> New Registration
                </a>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>

        <!-- Tabs -->
        <mat-tab-group (selectedIndexChange)="onTabChange($event)" class="my-20">
    <mat-tab label="Pending">
        <ng-container *ngTemplateOutlet="practitionerTable"></ng-container>
    </mat-tab>
    <mat-tab label="Approved">
        <ng-container *ngTemplateOutlet="practitionerTable"></ng-container>
    </mat-tab>
    <mat-tab label="Archived">
        <ng-container *ngTemplateOutlet="practitionerTable"></ng-container>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            Join requests
            @if (joinRequestCount > 0) {
                <span class="count-badge">{{ joinRequestCount }}</span>
            }
        </ng-template>
       <app-join-requests
    (countChange)="joinRequestCount = $event"
    (approved)="loadPractitioners()">
</app-join-requests>
    </mat-tab>
</mat-tab-group>

        <!-- Table Template -->
        <ng-template #practitionerTable>
            <app-table-header
                [patientsTableFilterArray]="tableFilter"
                [patientsFiltersFormControlObject]="tableFilterFormControlObject"
                [searchableFields]="searchableFields"
                [selectedSearchField]="selectedSearchField"
                [searchBoxTitle]="'Search Practitioners'"
                [hasData]="((tableDataLevel2 | async) ?? []).length > 0"
                [showWhenSearching]="true"
                (filterChanged)="onFilterChanged($event)"
                (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
            </app-table-header>

            @if((tableDataLevel2 | async)?.length === 0) {
                <app-empty-state
                    [title]="'No ' + pageTitle"
                    icon="hourglass_empty"
                    [subtitle]="currentSegment === 'pending' ? 'All practitioner registrations have been processed.' : currentSegment === 'archived' ? 'No archived practitioners.' : 'No approved practitioners yet.'">
                </app-empty-state>
            } @else {
                <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table my-30">
                    <!-- Number Column -->
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-icon [mat-menu-trigger-for]="menu">more_vert</mat-icon>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="viewDetails(element)">
                                    <mat-icon>visibility</mat-icon>
                                    <span>View Details</span>
                                </button>

                                @if(currentSegment === 'approved') {
                                    <button mat-menu-item (click)="editPractitioner(element)">
                                        <mat-icon>edit</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="archivePractitioner(element)">
                                        <mat-icon>archive</mat-icon>
                                        <span>Archive</span>
                                    </button>
                                }

                                @if(currentSegment === 'archived') {
                                    <button mat-menu-item (click)="reactivatePractitioner(element)">
                                        <mat-icon>restore</mat-icon>
                                        <span>Reactivate</span>
                                    </button>
                                }
                            </mat-menu>
                        </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.fullName) {
                                {{element.fullName}}
                            } @else if(element.name && element.name.length > 0) {
                                {{element.name[0].given?.[0]}} {{element.name[0].family}}
                            } @else if(element.firstName || element.lastName) {
                                {{element.firstName}} {{element.lastName}}
                            } @else {
                                <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Contact Column -->
                    <ng-container matColumnDef="contact">
                        <th mat-header-cell *matHeaderCellDef>Contact</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="contact-info">
                                @if(element.email) {
                                    <div>
                                        <a href="mailto:{{element.email}}">{{element.email}}</a>
                                    </div>
                                }
                                @if(element.phoneNumber) {
                                    <div>
                                        <a href="tel:{{element.phoneNumber}}">{{element.phoneNumber}}</a>
                                    </div>
                                }
                                @if(!element.email && !element.phoneNumber && element.telecom && element.telecom.length > 0) {
                                    @for(ct of element.telecom; track $index) {
                                        @if(ct.system === 'phone') {
                                            <div><a href="tel:{{ct.value}}">{{ct.value}}</a></div>
                                        }
                                        @if(ct.system === 'email') {
                                            <div><a href="mailto:{{ct.value}}">{{ct.value}}</a></div>
                                        }
                                    }
                                }
                                @if(!element.email && !element.phoneNumber && (!element.telecom || element.telecom.length === 0)) {
                                    <span class="subtitle-text-color-2">N/A</span>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <!-- Registration Date Column -->
                    <ng-container matColumnDef="registration date">
                        <th mat-header-cell *matHeaderCellDef>Registration Date</th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.registrationDate) {
                                {{element.registrationDate | date: 'short'}}
                            } @else if(element.submittedAt) {
                                {{element.submittedAt | date: 'short'}}
                            } @else if(element.createdAt) {
                                {{element.createdAt | date: 'short'}}
                            } @else {
                                <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Gender Column (only for approved/archived) -->
                    <ng-container matColumnDef="gender">
                        <th mat-header-cell *matHeaderCellDef>Gender</th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.gender) {
                                {{element.gender | titlecase}}
                            } @else {
                                <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Date of Birth Column (only for approved/archived) -->
                    <ng-container matColumnDef="date of birth">
                        <th mat-header-cell *matHeaderCellDef>Date of Birth</th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.birthDate) {
                                <div>
                                    <div>{{element.birthDate | date: 'shortDate'}}</div>
                                    <div class="subtitle-text-color-2">{{element.birthDate | age}} Years</div>
                                </div>
                            } @else {
                                <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Address Column (only for approved/archived) -->
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Address</th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.address?.[0]) {
                                <div>
                                    <div>{{element.address[0].line}}</div>
                                    <div class="subtitle-text-color-2">
                                        {{element.address[0].city}}, {{element.address[0].state}}
                                    </div>
                                </div>
                            } @else {
                                <span class="subtitle-text-color-2">N/A</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element">
                            @let statusValue = element.status || (element.active ? 'approved' : 'pending');
                            <div class="small-chips status-{{statusStyles[statusValue]['color']}} g-just-flex gap-8">
                                <span>{{statusValue}}</span>
                                <mat-icon>{{statusStyles[statusValue]['icon']}}</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumns" (click)="showRow(row)"></tr>
                </table>
            }
        </ng-template>
    </mat-card-content>
</mat-card>
